import { DocumentDto, EventDto } from '../../../interfaces/IEvent'
import AccordionSetup from '../AccordionSetup'
import AttachmentOutlinedIcon from '@mui/icons-material/AttachmentOutlined'
import AddCircleOutlineOutlined from '@mui/icons-material/AddCircleOutlineOutlined'
import UploadDocument from './UploadDocument'
import { useContext, useEffect, useState } from 'react'
import { EbAuthenticatedAppContext } from '@eidsivabredband/app-framework'
import { Box, Typography } from '@mui/material'
import { enqueueSnackbar } from 'notistack'
import DocumentSnippet from './DocumentSnippet'
import { LoadingIndicator } from '@eidsivabredband/react-component-ui-package'

interface DocumentContainerProps {
  viewEvent: EventDto
}

function DocumentContainer({ viewEvent }: DocumentContainerProps) {
  const { context } = useContext(EbAuthenticatedAppContext)
  const [openDocumentUpload, setOpenDocumentUpload] = useState(false)
  const [documents, setDocuments] = useState<DocumentDto[]>([])
  const [isLoading, setIsLoading] = useState(true)

  const handleOpenDocumentDialog = () => {
    setOpenDocumentUpload(true)
  }

  const handleCloseDocumentUpload = () => {
    setOpenDocumentUpload(false)
  }

  const handleUpdateDocumentView = () => {
    setOpenDocumentUpload(false)
    handleGetDocuments()
  }

  const handleGetDocuments = async () => {
    const response = await context.restApiClient.buildRequest(`/api/${viewEvent.id}/documents`).deserializeResponseToJson<DocumentDto[]>().getAsync()

    if (response.json) {
      setDocuments(response.json)
      setIsLoading(false)
    }

    if (response.error) {
      enqueueSnackbar(<Typography variant="body2">Kunne ikke hente dokumenter. Prøv igjen eller kontakt systemansvarlig.</Typography>, {
        variant: 'error',
      })
      setIsLoading(false)
    }
  }

  useEffect(() => {
    const getDocuments = async () => {
      await handleGetDocuments()
    }

    getDocuments()
  }, [])

  return (
    <>
      <AccordionSetup
        title="Dokumenter"
        contentHeight={400}
        icon={<AttachmentOutlinedIcon />}
        actionIcon={<AddCircleOutlineOutlined />}
        action={handleOpenDocumentDialog}
      >
        {isLoading && documents.length === 0 && (
          <Box style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <LoadingIndicator size={'small'} />
          </Box>
        )}
        {!isLoading && documents.length === 0 && <Typography variant="body2">Ingen dokumenter.</Typography>}
        {!isLoading &&
          documents.length > 0 &&
          documents
            .sort((a: DocumentDto, b: DocumentDto) => new Date(b.date).getTime() - new Date(a.date).getTime())
            .map((doc, index) => (
              <DocumentSnippet key={index} doc={doc} index={index} numberOfDocuments={documents.length} onUpdateView={handleGetDocuments} />
            ))}
      </AccordionSetup>

      <UploadDocument eventId={viewEvent.id} isOpen={openDocumentUpload} onClose={handleCloseDocumentUpload} onUpload={handleUpdateDocumentView} />
    </>
  )
}

export default DocumentContainer
